import React, { useState } from "react"
import Layout from "../../components/layout"
import SEO from "../../components/seo"
import BildHeader from "../../images/services/werkstatt/header.jpg"
import BildOben from "../../images/services/werkstatt/oben.jpg"
import Bild1 from "../../images/services/werkstatt/1.jpg"
import Bild2 from "../../images/services/werkstatt/2.jpg"
import SubNavigation from "../../components/SubNavServices"
import Termin from "../../components/Termin"

const Brillenwerkstatt: React.FC = () => {
  const siteTitle = "Brillenwerkstatt – Dienstleistungen"
  const [isSubMenuOpen, setSubMenuOpen] = useState(false)

  return (
    <Layout title={siteTitle}>
      <SEO title={siteTitle} />
      <section className="wrapper">
        <div className="headerImage">
          <img src={BildHeader} />
        </div>
      </section>
      <Termin />
      <SubNavigation
        isSubMenuOpen={isSubMenuOpen}
        setSubMenuOpen={setSubMenuOpen}
        activeMenuText="Brillenwerkstatt"
      />
      <section className="wrapper greyColor content">
        <h1>Brillenwerkstatt</h1>
        <h2 className="contentSubtitle">SCHWARZ Optik – Seit 1992 in Heiden</h2>
        <div className="contentColumns">
          <div className="contentColumn">
            <div className="imageCollection">
              <div className="imageRow">
                <img src={Bild1} />
              </div>
              <div className="imageRow">
                <img src={Bild2} />
              </div>
            </div>
            <p class="imageCaption">
              Zur Ausrüstung in der optischen Werkstatt zählen modernste
              CNC-Maschinen und Hochleistungsgeräte der Augenoptik.
            </p>
          </div>
          <div className="contentColumn">
            <h2>Sehhilfen auf Mass – gefertigt mit Erfahrung und Hightech.</h2>
            <p>
              In unserer hauseigenen Werkstatt entstehen aus hochwertigen Materialien individuelle Brillenlösungen – exakt abgestimmt auf Ihre Sehanforderungen, Ihr Gesicht und Ihren Lebensstil.
            </p>
            <p>
              Mit modernsten CNC-Schleifmaschinen, präzisen Zentriersystemen und viel handwerklichem Know-how garantieren wir nicht nur eine perfekte Passform, sondern auch höchste Qualität bei Glasbearbeitung, Montage und Feinanpassung.
            </p>

            <h2>Reparaturen & Anpassungen – schnell und unkompliziert.</h2>
            <p>
              Ob gebrochene Fassung, lockeres Glas oder verbogene Bügel, kleinere Reparaturen erledigen wir direkt vor Ort, oft innerhalb kürzester Zeit.
            </p>
            <p>
              Damit Ihre Brille nicht nur gut aussieht, sondern auch perfekt sitzt, jeden Tag.
            </p>
            <a
              href="https://www.click2date.eu/schwarz-optik.ch"
              target="_blank"
              rel="noreferrer"
              class="btn"
            >
              Ihre Brille – made by SCHWARZ Optik. Direkt in Heiden.
            </a>
          </div>
        </div>
      </section>
    </Layout>
  )
}

export default Brillenwerkstatt
